import { REHYDRATE_USER_BOOKING, BOOKING_MANAGEMENT_PROCESS_INIT, CHANGE_CHECKIN_DATE_FAILURE, HOTEL_REVIEW_PROCESS_REQUEST, CHANGE_CHECKIN_DATE_REMOVE_ERRORS, CHANGE_CHECKIN_DATE_REQUEST, CANCEL_TICKET_REQUEST, CHANGE_BOOKING_STATUS, CHANGING_CHECKING_DATE_FAILURE, CHANGING_CHECKING_DATE_INIT, CHANGING_CHECKING_DATE_SUCCESS, CHANGING_CHECKING_DATE_DEFAULT } from '../types';

export const beginBookingManagementProcess = hotel => ({ type: BOOKING_MANAGEMENT_PROCESS_INIT, payload: hotel });

export const submitHotelReview = survey => ({ type: HOTEL_REVIEW_PROCESS_REQUEST, payload: survey });

export const submitNewCheckinDate = date => ({ type: CHANGE_CHECKIN_DATE_REQUEST, payload: date });

export const changeCheckinDateFailure = message => ({ type: CHANGE_CHECKIN_DATE_FAILURE, payload: message });

export const changeCheckinDateRemoveErrors = () => ({ type: CHANGE_CHECKIN_DATE_REMOVE_ERRORS });

export const submitTicketCancellation = () => ({ type: CANCEL_TICKET_REQUEST });

export const changeBookingStatus = status => ({ type: CHANGE_BOOKING_STATUS, payload: status });

export const beginCheckinDateProcess = manageData => ({type: CHANGING_CHECKING_DATE_INIT, payload: manageData });

export const checkinDateProcessDefault = () => ({type: CHANGING_CHECKING_DATE_DEFAULT })

export const checkinDateProcessSuccess = date => ({type: CHANGING_CHECKING_DATE_SUCCESS, payload: date})

export const checkinDateProcessFailure = error => ({type: CHANGING_CHECKING_DATE_FAILURE, payload: error})

export const rehydrateBookingSession = session => ({ type: REHYDRATE_USER_BOOKING, payload: JSON.parse(session) });
